import buyingPowerBanner from '@/components/oz-buying-power-ldp/assets/folder/buying-power-banner.svg'

export default {
  name: 'oz-buying-power-banner',
  data () {
    return {
      buyingPowerBanner,
    }
  },
}
